// create persistent data storage on mobile ios and android
// https://github.com/litehelpers/Cordova-sqlite-storage
//https://cordova.apache.org/docs/en/latest/cordova/storage/storage.html
import Sql from './dbProviders/Sql.js';
import Local from './dbProviders/Local.js';
//import Indexed from './dbProviders/Indexed.js';

class StorageService{
    constructor(){

      this.options={
        name:"schoolsunited_database",
        displayName:"schoolsunited_database",
        version:"1.0",
        location:'default',
        androidDatabaseProvider: 'system',
        maxSize:11655360
    }
      this.provider;

      /*
      this.options={
        name:"schoolsunited_database",
        displayName:"schoolsunited_database",
        version:"1.0",
        location:'default',
        androidDatabaseProvider: 'system',
        maxSize:11655360
      }
      */
      
      
    }


    async ready(){

      // first try to open websql (or sqlite) plugin
      var _error;

      
      // try with Websql / cordova sqlite plugin
      this.provider=new Sql(this.options);
      await this.provider.openDatabase().then(
        ()=>{},
        error=>{
          _error+=error+",";
        }
      )
      

      // lets see if we have more luck connecting to localstorage
      if(_error){
        this.provider=new Local(this.options);
        await this.provider.openDatabase().then(
          ()=>{
            _error=undefined;
          },
          error=>{
            _error+=error+",";
          }
        )
      }

      

      
      // init database from here 
      await this.provider.createTable().then(
        ()=>{},
        error=>{
          return Promise.reject(error);
        }
      )
      
      
      // parse database to local array
      await this.provider.parseDatabase().then(
        ()=>{},
        error=>{
          return Promise.reject(error);
        }
      )
      
      if(!_error){
        return Promise.resolve("OK");
      }else{
        return Promise.reject(_error);
      }
      

    
    }


    /* interface for all providers*/
    setItem(key,val){
     this.provider.setItem(key,val);
     
    }
    /* interface for all providers*/
    getItem(key){
      return this.provider.getItem(key);
    }
    /* interface for all providers*/
    clear(){
      //this.provider.clear();
    }
    /* interface for all providers*/
    print(){
      //this.provider.print();
    }


  }

  export let storageService = new StorageService();